import { APP_VERSION_FALLBACK } from '../appVersion';

// Helper function to determine if we're in a development environment
const isDevelopment = () => {
  // Check if we're running locally
  const isLocalhost = window.location.hostname === 'localhost' ||
                     window.location.hostname === '127.0.0.1' ||
                     window.location.hostname.includes('192.168.');

  // Check if we're running in development mode (expo)
  const isExpo = window.location.hostname.includes('.expo.dev');

  // Check if we're in development mode explicitly
  const forceDev = process.env.REACT_APP_ENV === 'development' ||
                  process.env.NODE_ENV === 'development';

  return isLocalhost || isExpo || forceDev;
};

// Export the development mode flag
export const DEV_MODE = isDevelopment();

// Deploy target: staging, production, or development (from build env or hostname)
export const getDeployTarget = () => {
  if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_DEPLOY_TARGET) {
    return process.env.REACT_APP_DEPLOY_TARGET;
  }
  const h = typeof window !== 'undefined' && window.location && window.location.hostname ? window.location.hostname : '';
  if (h.includes('staging') || h.includes('vrc-staging')) return 'staging';
  if (h === 'localhost' || h === '127.0.0.1' || h.includes('192.168.')) return 'development';
  return 'production';
};

// App version: injected at build time, falls back to src/appVersion.js (always current)
export const APP_VERSION = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_VERSION) || APP_VERSION_FALLBACK || null;

// You can add more environment configurations here
export const config = {
  showComingSoon: !DEV_MODE,
  env: DEV_MODE ? 'development' : 'production',
  deployTarget: getDeployTarget(),
  appVersion: APP_VERSION,
};

// Log the current environment
console.log('Current environment:', {
  isDev: DEV_MODE,
  hostname: window.location.hostname,
  env: config.env,
}); 